import { render, staticRenderFns } from "./suspro.vue?vue&type=template&id=351027d2&scoped=true&"
import script from "./suspro.vue?vue&type=script&lang=js&"
export * from "./suspro.vue?vue&type=script&lang=js&"
import style0 from "./suspro.vue?vue&type=style&index=0&id=351027d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351027d2",
  null
  
)

export default component.exports